export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-[#FAF0E6] to-[#F5F5DC] overflow-hidden">
      <div className="hidden md:block absolute top-20 left-12 opacity-20">
        <img 
          alt="" 
          className="w-48 h-72 object-contain" 
          src="https://public.readdy.ai/ai/img_res/ba361179547a4ebca8273ec176a499c5.jpg"
        />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 pt-24 sm:pt-32 pb-12 sm:pb-20 flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
        <div className="flex-1 space-y-6 sm:space-y-8 text-center lg:text-left">
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-5 sm:p-6 shadow-sm border border-[#E8F5E9]">
            <p className="text-[#2C2C2C] leading-relaxed text-sm sm:text-base">
              <span className="font-bold text-[#66BB6A]">越谷・松伏の店舗・事業者のみなさまへ。</span><br />
              PC・Webが苦手なスタッフさんも、<br className="hidden sm:inline" />ゆっくり寄り添いながらサポートします。<br />
              個人で基礎から学びたい方も、気軽にご相談いただけます。
            </p>
          </div>
          <div className="inline-block bg-[#E8F5E9] text-[#66BB6A] px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-medium">
            よりみち相談室 WEB運営サポート
          </div>
          <div className="space-y-3 sm:space-y-4">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2C2C2C] leading-tight">
              ゆっくりでも、確実に。
            </h1>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-medium text-[#81C784]">
              できることが増えていく。
            </h2>
          </div>
          <p className="text-base sm:text-lg lg:text-xl text-[#757575] leading-relaxed max-w-2xl mx-auto lg:mx-0">
            PC・Web操作が苦手な方も安心。SNS・Canva・公式LINEなど、丁寧に寄り添いながらサポートします。
          </p>
          <button 
            onClick={scrollToContact}
            className="bg-[#66BB6A] text-white px-8 sm:px-10 py-3 sm:py-4 rounded-full hover:bg-[#4CAF50] transition-all text-base sm:text-lg font-medium inline-flex items-center gap-3 whitespace-nowrap cursor-pointer group"
          >
            まずは無料相談から
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </button>
        </div>
        <div className="flex-shrink-0 relative">
          <div className="w-64 h-64 sm:w-80 sm:h-80 lg:w-96 lg:h-96 rounded-full overflow-hidden shadow-2xl">
            <img 
              alt="サポート相談員 今野直子" 
              className="w-full h-full object-cover object-top" 
              src="https://static.readdy.ai/image/a94bf782443eac1605091ed034a69659/b72dd600887defa3ffcb32ace8722f20.jpeg"
            />
          </div>
          <div className="text-center mt-4 sm:mt-6">
            <p className="text-[#757575] text-base sm:text-lg">サポート相談員: 今野 直子</p>
          </div>
        </div>
      </div>
    </div>
  );
}